import React from "react";
import { WIDTH_IPAD } from "../../common/constant";

const StoreAgencyMap = (props: any) => {
  let map: any;
  let markers: any = [];
  const infoWindow = new google.maps.InfoWindow();
  const { currentPosition, center, stores, isSetCenter } = props;

  React.useEffect(() => {
    const handleResize = (e: any = null) => {
      const mapEl: any = document.querySelector("#map-desktop");
      const nearbyStoreEl: any = document.querySelector(".nearby-store-filter");

      if (mapEl && mapEl.style) {
        mapEl.style.height = `${(mapEl.offsetWidth * 895) / 1501}px`;

        if (nearbyStoreEl && nearbyStoreEl.style) {
          nearbyStoreEl.style.height = `${mapEl.clientHeight}px`;
        }
      }
    };

    if (window.innerWidth >= WIDTH_IPAD) {
      handleResize();

      window.addEventListener("resize", handleResize);
    } else {
      const mapEl: any = document.querySelector("#map-mobile");

      if (mapEl && mapEl.style) {
        mapEl.style.height = `calc(100vh - 120px)`;
      }
    }

    return () => {
      if (window.innerWidth >= WIDTH_IPAD) {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);

  React.useEffect(() => {
    initMap();

    if (stores.length) {
      stores.map((item: any) => addMarker(item));
    }
  }, [stores, isSetCenter]);

  const initMap = () => {
    if (center && center.lat) {
      const idMap = `map-${
        window.innerWidth >= WIDTH_IPAD ? "desktop" : "mobile"
      }`;

      map = new google.maps.Map(document.getElementById(idMap), {
        zoom: 14,
        center: center,
        fullscreenControl: false,
        zoomControl: false,
      });

      addMarker(currentPosition, false);

      map.addListener("click", () => {
        infoWindow.close();
      });
    }
  };

  const addMarker = (location: any, isAgency: any = true) => {
    const marker = new google.maps.Marker({
      position: !location.location
        ? { lat: location.lat, lng: location.lng }
        : {
            lat: +parseFloat(location.location.coordinates[1]),
            lng: +parseFloat(location.location.coordinates[0]),
          },
      map: map,
      icon: isAgency
        ? {
            // url: KdMarker,
            url: "https://kdstore.s3-ap-southeast-1.amazonaws.com/static/icons/kd-icon-88.svg",
            scaledSize: new google.maps.Size(24, 24), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(0, 0), // anchor
          }
        : null,
    });

    if (isAgency) {
      marker.addListener("click", () => {
        infoWindow.setContent(location.name);
        infoWindow.open(map, marker);
      });
    }

    markers.push(marker);
  };

  return (
    <div
      id={`map-${window.innerWidth >= WIDTH_IPAD ? "desktop" : "mobile"}`}
      style={{
        width: "100%",
        minHeight: 445,
      }}></div>
  );
};

export default StoreAgencyMap;
